import { render, staticRenderFns } from "./AddGuardianDialog.vue?vue&type=template&id=29822a1a&scoped=true&"
import script from "@/views/Users/Student/Dialogs/AddGuardianDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Dialogs/AddGuardianDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/Dialogs/add-guardian-dialog.scss?vue&type=style&index=0&id=29822a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29822a1a",
  null
  
)

export default component.exports